/* 🤖 this file was generated by script */
export const wsolidiconClock = {
  name: 'clock',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M1 12a11 11 0 1 1 22 0 11 11 0 0 1-22 0m12-6a1 1 0 1 0-2 0v6a1 1 0 0 0 .55.9l4 2a1 1 0 1 0 .9-1.8L13 11.39z" clip-rule="evenodd"/></svg>`,
  iconStyle: 'solid',
};
